import React from 'react'
import StartBtncom from '../../../../../component/Buttons/StartBtncom'

export default function StartBtn() {
  return (
    <div>
      <StartBtncom text={"Start"} count={"984.27"} />
    </div>
  );
}
